"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_1 = __importStar(require("react"));
const ActivityDetail_1 = __importDefault(require("./ActivityDetail"));
const IssueEditedActivity = ({ activity, position, }) => {
    const { what, from, to } = activity === null || activity === void 0 ? void 0 : activity.activityInfo;
    const parts = (0, react_1.useMemo)(() => {
        if (from && to) {
            return [
                'Changed ',
                react_1.default.createElement(ActivityDetail_1.default, { str: (0, core_1.capitalize)(what), key: `${activity === null || activity === void 0 ? void 0 : activity.title}_1` }),
                ' from ',
                react_1.default.createElement(ActivityDetail_1.default, { str: from, what: what, key: `${activity === null || activity === void 0 ? void 0 : activity.title}_2` }),
                ' to ',
                react_1.default.createElement(ActivityDetail_1.default, { str: to, what: what, key: `${activity === null || activity === void 0 ? void 0 : activity.title}_3` }),
            ];
        }
        else if (!from) {
            return [
                'Set ',
                react_1.default.createElement(ActivityDetail_1.default, { str: (0, core_1.capitalize)(what), key: `${activity === null || activity === void 0 ? void 0 : activity.title}_1` }),
                ' as ',
                react_1.default.createElement(ActivityDetail_1.default, { str: to, what: what, key: `${activity === null || activity === void 0 ? void 0 : activity.title}_2` }),
            ];
        }
        return [
            'Removed ',
            react_1.default.createElement(ActivityDetail_1.default, { str: from, what: what, key: `${activity === null || activity === void 0 ? void 0 : activity.title}_1` }),
            ' as ',
            react_1.default.createElement(ActivityDetail_1.default, { str: (0, core_1.capitalize)(what), key: `${activity === null || activity === void 0 ? void 0 : activity.title}_2` }),
        ];
    }, [activity.title, from, to, what]);
    return (react_1.default.createElement("span", { style: {
            textAlign: position,
            color: lib_palette_1.default.GreyBlue.main,
            fontSize: 12,
        } }, parts));
};
exports.default = IssueEditedActivity;
